module.exports = __webpack_public_path__ + "media/new_belt.f0186489.mp3";